import { Carousel as _Carousel } from "react-bootstrap";

export const Carousel = _Carousel;

export const CarouselItem = _Carousel.Item;
